import {Component, OnInit, EventEmitter} from '@angular/core';
import {OAClient} from '../../../../models/oaclient';
import Commons from "../../commons";
import {AuthRESTService} from '../../../services/rest/auth-rest.service';
import _ from 'lodash';
import {ActivatedRoute} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { UploaderOptions, UploadFile, UploadOutput } from 'ngx-uploader';
import {environment} from '../../../../../environments/environment';
import { AppWidgetModule } from 'app/components/widgets/widget.module';
import { SharedModule } from 'app/shared.module';

@Component({
    standalone: true,
    imports: [SharedModule, AppWidgetModule],
    selector: 'app-oaclient-edit',
    templateUrl: './oaclient-edit.component.html',
    styleUrls: ['./oaclient-edit.component.css']
})
export class OaclientEditComponent extends Commons implements OnInit {
	oaclient: OAClient = new OAClient();
	logoLabel: string = 'oaclient.logo';
	logoImageUrls: string [] = ['cas/OAuth2/file/'];
	logoSaveUrl: string = 'OAuth2/save/';
	errorMessage;

    constructor(private route: ActivatedRoute, private rest: AuthRESTService, toastr: ToastrService, translate: TranslateService) {
		super(toastr, translate);
	}

    ngOnInit() {
        this.route.params.subscribe(params => {
			this.rest.get(`OAuth2/client/${params['id']}`).subscribe((response) => {
				this.oaclient = response;
				this.logoImageUrls = this.logoImageUrls.map((url) => {
					return url + this.oaclient.id;
				});
				this.logoSaveUrl += this.oaclient.id;
            }, err => this.errorHandler(err))
		});
	}

	onLogoChange(ev) {
		this.logoImageUrls = ['cas/OAuth2/file/' + this.oaclient.id];
	}

    save(): void {
        this.clearNotifications();
        this.rest.post('OAuth2/client', this.oaclient).subscribe(() => {
			this.addSuccess('general.saved')
        }, err => this.errorHandler(err))
    }
}
